import * as React from 'react';
import {Modal} from 'antd';

import locales from '../locales';
import {ErrorAlert} from '../common/ErrorAlert';
import {
  ErrorResponse,
  InventoryStockItemStateFilter,
  MoveInventoryStockItemsRequest,
  User,
  Warehouse
} from '../api/dtos/dtos';
import furoApi from "../api/FuroApi";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import InventoryStockItemStateSelector from './InventoryStockItemStateSelector';

interface Props {
  selectedItemIds: number[];
  users: User[];
  warehouses: Warehouse[];
  onCancel: () => void;
  onConfirm: () => void;
}

interface State {
  error?: ErrorResponse;
}

class InventoryStockItemsMoveModal extends React.Component<Props, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {
    error: undefined,
  };

  public render(): React.ReactNode {
    const {error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <Modal
          visible={true}
          title={locales.move_items_confirm}
          footer={null}
          onCancel={this.props.onCancel}
        >
          <InventoryStockItemStateSelector
            users={this.props.users}
            warehouses={this.props.warehouses}
            onOk={this.onOk}
            onCancel={this.props.onCancel}
            okText={locales.move}
          />

          <ErrorAlert style={{marginTop: '16px'}} error={error}/>
        </Modal>
      </>
    );
  }

  private onOk = (stateFilter: InventoryStockItemStateFilter) => {
    const {selectedItemIds, onConfirm} = this.props;

    if (!stateFilter?.targetType) {
      this.setState({error: {message: locales.move_invalid_target}});
      return;
    }

    const request: MoveInventoryStockItemsRequest = {
      ids: selectedItemIds,
      ...(stateFilter.targetType === 'user' ? {userId: stateFilter.userId} : {}),
      ...(stateFilter.targetType === 'warehouse' ? {warehouseId: stateFilter.warehouseId} : {}),
      ...(stateFilter.targetType === 'internallyUsed'
        ? {internallyUsed: true, internallyUsedItemId: stateFilter.item?.id}
        : {}),
    };

    const promise = furoApi.inventoryStockItems.move(request)
      .then(onConfirm)
      .catch(this.onApiError);

    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => this.setState({error});
}

export default InventoryStockItemsMoveModal;



// WEBPACK FOOTER //
// ./src/inventory-stock-details/InventoryStockItemsMoveModal.tsx